import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'

interface IToolTip {
    className?: string
    text?: string
}

const ToolTip: React.FC<IToolTip> = ({ className, text }) => {
    const [isOpened, setIsOpened] = useState<boolean>(false)

    const ToggleToolTip = () => {
        if (!isOpened) {
            setTimeout(() => {
                setIsOpened(!isOpened)
            }, 1000)
        } else {
            setIsOpened(!isOpened)
        }

    }

    return (
        <span className={clsx("w-[18px] h-[18px] relative inline-flex items-center justify-center", className)}>
            <FontAwesomeIcon icon={faCircleInfo} className="w-full h-full text-white/[0.66] cursor-pointer" onMouseEnter={ToggleToolTip} onMouseLeave={ToggleToolTip} />

            {(isOpened && text) && <span className='absolute z-10 bg-[linear-gradient(180deg,#18224A,#0C1330)] border border-white/[0.15] text-center px-4 py-3 rounded-toast shadow-card w-[250px] bottom-[28px] left-[50%] animate-tooltip-show'>
                <span className='block text-sm text-white font-medium leading-6'>{text}</span>
            </span>}
        </span>
    )
}

export default ToolTip
